<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="nbCandidatReduit.non"

	[label]="step2.getspan14"
	[type]="'radio'"
	[rule]="''"
	[radios]="[
		{
			label: step2.getoui,
			value: 'Oui'
		},
		{
			label: step2.getnon,
			value: 'Non'
		}
	]"
	[name]="getUid() + '_SepAtt_non'"
>
</app-form-input>

<!---->

<app-oui-type-oui-non-nb-candidat-reduitFNS-simple
	*ngIf="isNbCandidatReduitOui()"
	[uid]="getUid()"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[oui]="nbCandidatReduit.oui"
></app-oui-type-oui-non-nb-candidat-reduitFNS-simple>
